// Port of api/fuel/app/classes/filter/search/games/rules/query/publishers.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'publishers',
	isIndex: function() { return 'publisher' }
})
